export function formatTime(inputTime: string) {
    const time = inputTime
    const formattedTime = time.slice(0, 5)
    return formattedTime
}

export function getDayOfWeek(dayNumber: number): string {
    const daysOfWeek = [
        "Sunday",    // Index 0, corresponds to 1
        "Monday",    // Index 1, corresponds to 2
        "Tuesday",   // Index 2, corresponds to 3
        "Wednesday", // Index 3, corresponds to 4
        "Thursday",  // Index 4, corresponds to 5
        "Friday",    // Index 5, corresponds to 6
        "Saturday"   // Index 6, corresponds to 7
    ]

    if (dayNumber < 1 || dayNumber > 7) {
        return "Invalidate Day"
    }

    return daysOfWeek[dayNumber - 1]
}